import { render, staticRenderFns } from "./wrapperRankingScore.vue?vue&type=template&id=4e54e286&"
import script from "./wrapperRankingScore.vue?vue&type=script&lang=js&"
export * from "./wrapperRankingScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports